'use client';

import Icon from './Icon';
import svg from 'sprites/pin.svg';

export default function IconPin({
  className='w-15 h-16'
}: {
  className?: string;
}) {
  return <Icon id={svg.id} className={className} />;
}